module.exports = __webpack_public_path__ + "static/media/SO1.345cc428.jpg";